import { render, staticRenderFns } from "./VClockTargets.vue?vue&type=template&id=2b1d78f8&"
import script from "./VClockTargets.vue?vue&type=script&lang=js&"
export * from "./VClockTargets.vue?vue&type=script&lang=js&"
import style0 from "./VClockTargets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports